import Link from "next/link";
import { ArrowRight, ArrowUpRight, Sparkles } from "lucide-react";
import RegisterButton from "@/components/home/RegisterButton";
import buttonStyles from "@/components/home/home.module.css";
import styles from "./institutional-cta.module.css";

type InstitutionalCtaProps = {
  title: string;
  description: string;
  buttonText?: string;
  /** Without a destination, use the existing registration selection modal. */
  buttonHref?: string;
  secondaryAction?: { text: string; href: string };
  variant?: "default" | "journey";
};

export default function InstitutionalCta({
  title,
  description,
  buttonText = "Começar agora",
  buttonHref,
  secondaryAction,
  variant = "default",
}: InstitutionalCtaProps) {
  const primaryAction = buttonHref ? (
    <Link
      href={buttonHref}
      className={`${buttonStyles.button} ${buttonStyles.lightButton} ${styles.primary}`}
    >
      {buttonText} <ArrowUpRight size={17} />
    </Link>
  ) : (
    <RegisterButton light label={buttonText} className={styles.primary} />
  );

  return (
    <section
      data-institutional-cta
      className={`${styles.band} ${variant === "journey" ? styles.journey : ""}`}
    >
      <div className={styles.container}>
        {variant === "default" && <Sparkles size={34} />}
        <div>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.description}>{description}</p>
        </div>
        {secondaryAction ? (
          <div className={styles.actions}>
            <Link href={secondaryAction.href} className={styles.secondary}>
              {secondaryAction.text} <ArrowRight size={17} />
            </Link>
            {primaryAction}
          </div>
        ) : primaryAction}
      </div>
    </section>
  );
}
